import { Dispatch, FC } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { useNavigate } from 'react-router';
import { Action } from 'redux';

import lang from '../../lib/language';
import { logout as serviceLogout } from '../../lib/store/common-actions';

import IconBack from '../../assets/img/icon-arrow_back.svg';
import IconCloseWhite from '../../assets/img/icon-close-white.svg';
import { useIsMobile } from '../../hooks';
import { UI_ROUTES } from '../../util/routes';
import { ClickableImage, GoBackButton, HeaderLogo } from '../index';

import styles from './LogoAndCloseButton.module.scss';

type Props = {
  onBackBtnPress?: Function;
  onClose?: Function;
  displayBackButton: boolean;
  displayCloseButton: boolean;
  text?: string;
  newWebGoBackButtonDesign?: boolean;
} & ReduxProps;

const LogoAndCloseButton: FC<Props> = (props: Props): JSX.Element => {
  const {
    onBackBtnPress,
    onClose,
    displayCloseButton,
    displayBackButton,
    logout,
    text,
    newWebGoBackButtonDesign,
  } = props;
  const navigate = useNavigate();
  const { isMobile } = useIsMobile();

  const handleLogout = () => {
    if (onClose) {
      onClose();
      return;
    }

    logout();
    navigate(UI_ROUTES.signUp);
  };

  if (isMobile) {
    return displayBackButton ? (
      <div className={styles.backIcon}>
        <ClickableImage
          alt="Back"
          src={IconBack}
          className={styles.backIconMobile}
          onClick={() => (onBackBtnPress ? onBackBtnPress() : navigate(-1))}
        />
      </div>
    ) : (
      <></>
    );
  }

  return (
    <div className={styles.logoAndBackButtonContainer}>
      <HeaderLogo className={styles.logoAce} />
      <div className={styles.textContainer}>
        {displayBackButton && !newWebGoBackButtonDesign && (
          <div className={styles.backIcon}>
            <ClickableImage
              alt="Back"
              src={IconBack}
              onClick={() => (onBackBtnPress ? onBackBtnPress() : navigate(-1))}
              style={{ cursor: 'pointer' }}
            />
            <span className={styles.backText}>{lang.commonBack()}</span>
          </div>
        )}
        {displayBackButton && newWebGoBackButtonDesign && (
          <div className={styles.backIconNew}>
            <GoBackButton
              onBackBtnPress={() => (onBackBtnPress ? onBackBtnPress() : navigate(-1))}
            />
          </div>
        )}
        {text && <div className={styles.text}>{text}</div>}
      </div>
      {displayCloseButton && (
        <ClickableImage
          alt=""
          src={IconCloseWhite}
          className={styles.closeIcon}
          onClick={handleLogout}
          style={{ cursor: 'pointer' }}
        />
      )}
    </div>
  );
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  logout: () => dispatch(serviceLogout()),
});

const connector = connect(null, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(LogoAndCloseButton);
